import React, { useRef, useState, useEffect } from 'react'
import { useFormik } from 'formik';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import Select from 'react-select';
// import { adminMainUrl } from '../../Config';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { adminMainUrl } from '../../../../Config';

const EditMaster = ({ show, handleClose, onSuccess, MasterID, MasterName, MasterCategory }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const CategoryOption = [
        { value: 'FREIGHT_FORWARDING', label: 'Freight forwading' },
        { value: 'CUSTOM_CLEARENCE', label: 'Custom clearence' },
        { value: 'BOTH', label: 'Both' },
    ]
    useEffect(() => {
        if (MasterID) {
            formik.setValues({
                id: `${MasterID}`,
                name: MasterName,
                service_type: MasterCategory
            });
        }
    }, [MasterID, MasterName]);
    const closeButtonRef = useRef(null);
    const validationSchema = Yup.object({
        name: Yup.string().required('Charge head is required'),
        service_type: Yup.string().required('Category is required'),
    });

    // Initialize Formik
    const formik = useFormik({
        initialValues: {
            id: `${MasterID}` || '',
            name: MasterName || '',
            service_type: MasterCategory || ''
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            setIsSubmitting(true);
            try {
                const response = await fetch(`${adminMainUrl}/api/chargehead/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id')
                    },
                    body: JSON.stringify(values),
                });

                const data = await response.json();

                if (response.ok) {
                    // closeButtonRef.current.click();
                    if (onSuccess) onSuccess();
                    toast.success(data?.msg);
                    handleClose()
                } else {
                    toast.error(data?.msg);
                }
            } catch (error) {
                console.error('Network error:', error);
            }
            finally {
                setIsSubmitting(false); // Stop the spinner
            }
        },
    });
    return (
        <Offcanvas className="custom-offcanvas" show={show} onHide={handleClose} placement="end">
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Charge Head</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">
                        <div className="col-12">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Category <span style={{ color: 'red' }}>*</span>
                                </label>
                                <Select
                                    name='service_type'
                                    className='custom-selector'
                                    options={CategoryOption}
                                    value={CategoryOption.find(option => option.value === formik.values.service_type) || null} // Control the value based on Formik's state
                                    onChange={(selectedOption) => formik.setFieldValue("service_type", selectedOption.value)} // Set the correct field in Formik
                                    onBlur={formik.handleBlur}
                                />
                                {formik.touched.service_type && formik.errors.service_type ? (
                                    <div className="error">{formik.errors.service_type}</div>
                                ) : null}
                            </div>

                        </div>
                        <div className="col-12">
                            <div className="mb-3">
                                <label htmlFor="name" className="form-label">
                                    Charge head <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    id="name"
                                    name="name"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.name}
                                />
                                {formik.touched.name && formik.errors.name ? (
                                    <div className="error">{formik.errors.name}</div>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex justify-content-end">
                        <button className="btn btn-primary text-xs" type="submit" disabled={isSubmitting}>
                            {isSubmitting ? <i className="fa fa-spinner fa-spin" /> : "Update"}
                        </button>
                    </div>

                </form>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default EditMaster